import React from 'react';
import './ads.scss';
import { useParams } from 'react-router-dom';
import AdsSinglePage from '../AdsSinglePage/AdsSinglePage';
import LiveAds from '../LiveAds/LiveAds';

const Ads = () => {
    const { adsId } = useParams(); // Destructure adsId from useParams
    
    return <AdsSinglePage activeAddId={adsId} />;
}

export default Ads;